import { __exports as url } from './_virtual-url2.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireLiveSiteClient } from './vp-js-token-engine-build-services-liveSiteClient.js';

var hasRequiredUrl;

function requireUrl () {
	if (hasRequiredUrl) return url;
	hasRequiredUrl = 1;

	Object.defineProperty(url, "__esModule", {
	  value: true
	});
	url.getShippingUrl = getShippingUrl;
	url.getUrl = getUrl;
	url.name = void 0;
	var _container = requireContainer();
	var _liveSiteClient = requireLiveSiteClient();
	url.name = 'url';
	async function getUrl(scope, pageId, fullUrl) {
	  const culture = _container.contextService.getCulture(scope);
	  const tenant = _container.contextService.getTenant(scope);
	  if (!tenant) {
	    throw new Error('tenant not set');
	  }
	  const urlClient = _container.contextService.getUrlClient(scope);
	  const slug = await urlClient.getPageSlug(pageId, culture, tenant);
	  if (slug === '#') {
	    return slug;
	  }
	  if (fullUrl) {
	    const host = await (0, _liveSiteClient.getHost)(culture, tenant);
	    return "".concat(host).concat(slug);
	  }
	  return slug;
	}
	function getShippingUrl(scope) {
	  const shippingUrls = {
	    promotique: 'https://www.promotique.de/lieferung',
	    vistaprint: 'https://www.vistaprint.de/lieferung'
	  };
	  let tenant = _container.contextService.getTenant(scope);
	  if (tenant === undefined) {
	    tenant = 'vistaprint';
	  }
	  tenant = tenant.toLowerCase();
	  if (!shippingUrls[tenant]) {
	    throw new Error('tenant not supported');
	  }
	  return "".concat(shippingUrls[tenant]);
	}
	
	return url;
}

export { requireUrl as __require };
//# sourceMappingURL=vp-js-token-engine-build-common-url.js.map
